import {MetricTextRenderer} from '../analyticsFormatHelpers';

export const renderTextValue: MetricTextRenderer = ({value}) => value;
